import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../context/AuthContext';
import { putCustReqVfy, putTrkOpReqVfy } from '../services/req_service';
import { customAlert, notify } from './notify';
import CustomDropDown from './CustomDropDown';


function UpdateReqVfyPopup({ modalOpen, handleModalClose, reqId, reqStatus, userType, price }) {

    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    // console.log("1----------------------------")
    // console.log(reqStatus)
    const ddArrCustBase = [
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" },
        { value: "lrupdate", label: "LR Update" },
    ]

    // if reqStatus === "pending", remove "approved"
    const ddArrCust =
        (reqStatus === "pending" || reqStatus === "rejected" || (reqStatus === "lrupdate" && price < 0))
            ? ddArrCustBase.filter(item => item.value !== "approved")
            : ddArrCustBase;

    const ddArrTrk = [
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" },
    ]


        async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);

        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            // console.log("-----------------=================")
            // console.log(userType)
            // console.log(reqId)
            // console.log("-----------------=================")
            if (userType === 'cust') {
                await putCustReqVfy({ custReqId: reqId, reqStatus: inputObject?.reqStatus })
            } else {
                await putTrkOpReqVfy({ trkOpReqId: reqId, reqStatus: inputObject?.reqStatus })
            }
            notify("success", "Updated Successfully");
            handleModalClose();
            queryClient.invalidateQueries();
        } catch (err) {
            // console.log(err);
            if (err === 409) {
                notify("error", "Not Authorized");
            } else
                customAlert(err);
        }
        setLoadingScreen(false)
    }



    return (
        <Modal key={`updatePopup-${reqId}`}
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {reqStatus ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={3}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>{t("bo.custInfoPg.updateReqVfy")}</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <CustomDropDown key={`reqDD-${reqId}`} title={t("bo.updSts.sts")} name={"reqStatus"} errMsg={formErrors.reqStatus} value={reqStatus} ddArr={userType === "cust" ? ddArrCust : ddArrTrk} width={400} />

                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400}>
                            <Button variant="text" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("bo.updSts.cancel")}</Button>
                            <Button variant="contained" type='submit' sx={{ height: 40, width: 150 }}>{t("bo.updSts.save")}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default UpdateReqVfyPopup;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};

function validate(values) {
    const errors = {};

    if (!values.reqStatus)
        errors.status = "Status is required!";

    return errors;
};